import { toast } from '@britishcouncil/react-admin';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { generatePath, useLocation, useNavigate } from 'react-router';
import { lrwSessionStore } from 'store';
import { parseServerErrors } from 'utils';

export const useLinkExistingSpeakingSession = () => {
  const lrwSessionId = useIntParam('sessionId');
  const location = useLocation();
  const navigate = useNavigate();
  const { lrwSessionDetails } = ROUTING_PATHS;
  const [selectedSpeakingSession, setSelectedSpeakingSession] = useState<number>();

  const [
    linkSpeakingSession,
    { isLoading: isLinking, isSuccess: linked, error: linkErrors, reset },
  ] = lrwSessionStore.service.useLinkSpeakingSessionMutation();

  const onLink = () => {
    linkSpeakingSession({ lrwSessionId, speakingSessionId: selectedSpeakingSession! });
  };

  const goToLrwSessionDetails = useCallback(
    (sessionId: number) =>
      navigate(generatePath(lrwSessionDetails.absolutePath, { sessionId }), {
        state: location.state,
      }),
    [location.state, navigate, lrwSessionDetails.absolutePath]
  );

  useEffect(() => {
    if (linked) {
      toast({
        type: 'success',
        title: 'Success',
        message: 'Changes saved successfully',
      });
      goToLrwSessionDetails(lrwSessionId);
      reset();
    }
  }, [goToLrwSessionDetails, linked, lrwSessionId, reset]);

  const serverErrors = useMemo(() => parseServerErrors(linkErrors), [linkErrors]);

  return {
    selectedSpeakingSession,
    setSelectedSpeakingSession,
    isLinking,
    linked,
    onLink,
    serverErrors,
  };
};
